import React, { useEffect, useState } from 'react'
import TimeTaxSupportSystemClient from '../../../system';
import MessageCourier from '../../../lib/MessageCourier';
import { User } from '../../../system/User';
import HeaderReusable, { IHeaderActionButton } from '../HeaderEmpresa';
import { FieldValues, useForm } from 'react-hook-form';
import { spanishDatePickerStrings } from '../../Collaborator/CollaboratorView/collaboratorCreateView';
import { ComboBox, Toggle,DatePicker, Icon, TextField } from '@fluentui/react';
import { DateCustom } from '../../../lib/DateCustom';
import formatearFecha from '../../../common/formatDate';
import useAsyncDataCourier from '../../../common/custom-hooks/useAsyncDataCourier';
import { ButtonProps, CustomModalEmp } from '../CustomModalEmp';
import { t } from 'i18next';
import '../empresas.css';
import { CustomTextFilEmpesas } from '../CustomTextFil';
import { Isoapruc } from '../../../system/company/Company';
import CollaboratorSelector from '../../../shared/components/CollaboratorSelector';
import RubroSelector from '../../../shared/components/RubroSelector';
import PaisSelector from '../../../shared/components/PaisSelector';
import SmartSelect from '../../../shared/components/SmartSelect';

interface InuevaEmpresa {
  setpantalla:(cod:number)=>void
  system: TimeTaxSupportSystemClient;
  courier: MessageCourier;
  changeBlockUI: (change: boolean) => void;
  user: User;
  uuid: string;
}

function NewEmpresa({setpantalla,system,courier,changeBlockUI,uuid}:InuevaEmpresa) {
   const {handleSubmit,register,setValue,watch,formState:{errors},clearErrors} = useForm();
   const [numruc,setNumruc] = useState<string | undefined>('');
   const [facturable,setFacturable] = useState<boolean | undefined>(true);
   const [loadingSoap, setLoadingSoap] = useState<boolean>(false);
   const [dataSoap, setDataSoap] = useState<Isoapruc | undefined>(undefined);
   const [errorSoap, setErrorSoap] = useState<number>(0);
   const [modal, setModal] = useState<boolean>(false);

   const buttonaction:IHeaderActionButton[] = [
    {
      label: t("Guardar"),
      iconName: "Save",
      onClick: () => HamdlerErrorSubmit(),
      className: "Button_view"
    },
    {
      label: t("Volver"),
      iconName: "Back",
      onClick: () => {
        setpantalla(1);
      },
      className: "Button_back",
    },
  ];

   const buttonsOtion:ButtonProps[] = [{ text: "SI", onClick: ()=>modalButtons(),primary:true },{text:'NO',onClick:()=>setModal(false)}];

  const infoSoap = async (id:string)=>{
   const menssage = 'se optiene informacion atraves del ruc'
     return await system.getCompanySystem().getInfoSoap(uuid,menssage,id);
  }
  
  const handleDateChange = (date,name:string) => {
    if(!date)return;
    register(name,{required:true});
    const ddat = formatearFecha(date)
    setValue(name,ddat);
  };

  const onChangeRuc = async (text: string | undefined) => {
    setErrorSoap(0);
    setNumruc(text);
    setValue('nif', text);

    const normalize = (str?: string) =>
      str?.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    const isPeru = normalize(watch("pais")?.label) === "peru";

    const textLength = text?.length || 0;
    const isNumeric = /^[0-9]+$/.test(text ?? "");
    const isValidRuc = /^[12]0\d{9}$/.test(text ?? ""); // Solo 10 o 20 + 9 dígitos

    if (isPeru && isValidRuc) {
      setLoadingSoap(true);
      const result = await infoSoap(text!);
      if (result?.ruc) {
        setDataSoap(result);
      } else {
        setErrorSoap(1);
      }
      setLoadingSoap(false);
    } else if (isPeru && textLength > 2 && !isNumeric) {
      setErrorSoap(2);
    }
  };

  const handlerfacturable = (cheked:boolean | undefined)=>{
    setFacturable(cheked);
    setValue('facturable',cheked?1:0);
  }

  const direccioneEnsamble = (data:Isoapruc | undefined)=>{
    if(data){
      return `${data.codigozona} ${data.nombrevia} ${data.numero} ${data.tipovia} ${data.tipozona}`
    }
    return undefined;
  }


  const validateDate = ():boolean=>{
    const dateString = watch('fechaingreso');
    const dateToday = DateCustom.FormatDatetoAMDStr(new Date());
    return dateString < dateToday;
  }

  const modalButtons =async ()=>{
    setModal(false)
    await HandlerSubmit()
    setpantalla(1);
  }
  
  const HandlerSubmit = handleSubmit(async(data: FieldValues)=>{
    if(data){
      changeBlockUI(true);
        const result = await system.getCompanySystem().createCompany(data,uuid,'create-company');
         if(result?.status === 'success'){
          changeBlockUI(false);
          courier.messageSuccess(t('La empresa se ha creado correctamente.'));
          // Remover el ls para que se actualize el contexto cuando se crea o edita un proyecto 
          localStorage.removeItem("/proyectoDVM/getFormContext")
         }else{
          courier.messageError(t('La empresa no se ha podido crear.'));
         }
    }
    changeBlockUI(false);
  });

  const HamdlerErrorSubmit = handleSubmit(async(data: FieldValues)=>{
    console.log({errorSoap, data});
    
      if(errorSoap === 0){
        setModal(true);
      } 
  });

    useEffect(()=>{
      register("fechaingreso",{required:true});
      register("tipemp",{required:true});
      register("pais",{required:true});
      register("nif",{required:true});
      register("facturable",{required:true,value:facturable?1:0});
      register("ciudad",{required:true});
      register("distrito",{required:true});
      register("direccion",{required:true});
      register("name",{required:true});
      register("emp_responsable_colid", { required: false });
      register("rubros", { required: false });
    },[]);

    useEffect(()=>{
      if(watch("pais")?.text === "Perú"){
        clearErrors("nif");
        register("nif",{required:true, minLength:11, maxLength:11});
      }else{
        clearErrors("nif");
        register("nif",{required:true, minLength:undefined, maxLength:undefined});
        setErrorSoap(0);
      }
    },[watch("pais")]);

    // valida si el RUC empieza con "10"
    useEffect(() => {
      const ruc = watch("nif") ?? "";
      const isRuc10 = ruc.startsWith("10");

      if (isRuc10) {
        // Si es RUC 10, los campos dejan de ser requeridos
        clearErrors(["ciudad", "distrito", "direccion"]);
        register("ciudad", { required: false });
        register("distrito", { required: false });
        register("direccion", { required: false });
      } else {
        // Si no es RUC 10 (ej. 20...), los vuelve requeridos
        register("ciudad", { required: true });
        register("distrito", { required: true });
        register("direccion", { required: true });
      }
    }, [watch("nif")]);


  return (
    <>
    <form style={{ backgroundColor:'#faf9f8'}} > 
     <HeaderReusable
      title={t("Empresas")}
      icontitle='CityNext'
      actions={buttonaction}
      />
      <div style={{height:'100%',width:'100%',paddingBottom:'20px'}}>
        <div className='body-nuevo-colaborador'>
          <Icon iconName="CityNext" style={{ fontSize: "22px" }} />
          <p>{t("Nueva empresa:")}</p>
        </div>
        <div className='style-body-form-emp'>
            
            <p className="titulo_form_create">
              <Icon iconName="ContactCard" style={{fontSize:"30px"}} />
              {t("Información general.")}
            </p>
            <div className='form_informacion_general_cuerpo'>
            <SmartSelect 
              className='input_reusable mt-1'
              options={[{key:'vinculada',label:'Vinculada', text: 'Vinculada'},{key:'CDA',label:'CDA', text: 'CDA'}]}
              label={t('Tipo de empresa')} placeholder={t('selecione el tipo de empresa')} styles={{ width:"250px"}}
              onChangeSelected={(option)=> setValue('tipemp', option ? {...option, text: option.label} : undefined) } 
            /> 
            {errors.tipemp?.type === 'required' && <span className='styl-error' > {t('El tipo de empresa no puede ser vacío.')}</span>}

            <span style={{marginTop:'-45px',marginBottom:'-45px'}} >
              <Toggle label={t('Facturable')} onChange={(_,cheked)=>handlerfacturable(cheked)} checked={facturable} />
            </span>

            <PaisSelector 
              className='input_reusable mt-1'
              label={t("País")}
              placeholder={t('Escribe el país')}
              styles={{ width:"250px", marginBottom:'-45px' }}
              system={system}
              onChangeSelected={(option) => {
                setValue("pais", option)
              }}
            />
            {errors.pais?.type === 'required' && <span className='styl-space-error'> {t('El país no puede ser vacío.')}</span>}
           
            <div style={{display:'flex',flexDirection:'row',gap:'40px'}}>
                <span className="input_reusable">
                  <TextField styles={{root:{width:'250px', height:'14px'}}}  placeholder={t('Escribe el código')}  label={t('NIF(número de identificación fiscal)')}
                    type='text' onChange={(_,text)=>onChangeRuc(text)} value={numruc} disabled={loadingSoap} 
                  />
                 {errors.nif?.type === 'required' && <span className='style-botton-error' > {t('El código no puede ser vacío.')}</span>}
                 {((errors.nif?.type === 'maxLength')||(errors.nif?.type === 'minLength')) && <span className='style-botton-error' > {t('El código debe tener 11 caracteres.')}</span>}
                 {errorSoap === 1 && <span className='style-botton-error' > {t('Número de ruc invalido.')}</span>}
                 {errorSoap === 2 && <span className='style-botton-error' > {t('El ruc solo permite números.')}</span>}
                </span>
                
                <CustomTextFilEmpesas key="003" width="250px" height="14px" label={t('Nombre')} placeholder={t('Escribe el nombre')}
                  name='name' setValue={setValue} type='text' disabled={loadingSoap} value={dataSoap?.razonsocial} errors={errors}
                />
            
            </div>
            <div style={{display:'flex',flexDirection:'row',gap:'40px'}}> 
                <CustomTextFilEmpesas key="004" width="250px" height="14px" label={t('Ciudad')} placeholder={t('Escribe la ciudad')}
                 name='ciudad' setValue={setValue} type='text' disabled={loadingSoap} value={dataSoap?.departamento} errors={errors}
                />
                <CustomTextFilEmpesas key="005" width="250px" height="14px" label={t('Distrito')} placeholder={t('Escribe la distrito')} 
                name='distrito' setValue={setValue} type='text' disabled={loadingSoap} value={dataSoap?.distrito} errors={errors}
                />
                <CustomTextFilEmpesas key="006" width="300px" height="14px" label={t('Dirección')} placeholder={t('Escribe la dirección')} errors={errors} paddingLeft='315px'
                name='direccion' setValue={setValue} type='text' disabled={loadingSoap} value={dataSoap?direccioneEnsamble(dataSoap):undefined}
                />
            </div>
            <DatePicker strings={spanishDatePickerStrings} allowTextInput formatDate={DateCustom.formatDateForDatePicker} label={t("Fecha de registro")}
             className="emmp_label_reusable" placeholder={t("Seleccione la fecha de ingreso")} styles={{root:{width:"280px"}}}
              onSelectDate={(date)=>handleDateChange(date,"fechaingreso")} />
            {errors.fechaingreso && <span className='styl-error' > {t('La fecha de ingreso no puede ser vacío.')}</span>}
            </div>
            
            <div className='form_informacion_general_cuerpo'>            
              <CollaboratorSelector
                system={system}
                label={t("Responsable")}
                className='input_reusable mt-1'
                placeholder={t("Seleccione el responsable...")}
                onChangeSelected={(colaborador) => {
                  // Guarda el colaborador seleccionado en el formulario
                  setValue("emp_responsable_colid", colaborador?.col_id);
                }}
                styles={{ width:"280px" }}
              />
              {errors.emp_responsable_colid && (
                <span className='styl-error'>
                  {t('El responsable no puede ser vacío.')}
                </span>
              )}
            </div>

            <div className='form_informacion_general_cuerpo'>
              <RubroSelector
                className='input_reusable mt-1'
                system={system}
                label={t("Rubros")}
                placeholder={t("Seleccione hasta 2 rubros")}
                maxSelection={2} // cantidad máxima de rubros seleccionables
                onChangeSelected={(selectedRubros) => {
                  const rubIds = selectedRubros.map(r => r.rub_id);
                  setValue("rubros", rubIds);
                }}
                styles={{  width: '280px'  }}
              />
              {errors.rubros && (
                <span className='styl-error'>
                  {t('Debes seleccionar al menos un rubro.')}
                </span>
              )}
            </div>
        </div>
      </div>
    </form>
    <CustomModalEmp isOpen={modal} iconName='Warning'
    message={t("La información de la empresa a crear no actualiza / modifica proyectos ni actividades generadas.")}
    question={t("¿Deseas continuar con la creación de la empresa?")}
    buttons={buttonsOtion}
    message2={validateDate()?t("La fecha de registro es menor a la fecha actual."):undefined}
     />
    </>
  )
}

export default NewEmpresa;